module.exports = __webpack_public_path__ + "img/30.b8037139.jpg";